export default "__VITE_ASSET__745b83f2__"